import React from 'react'
import { Loader } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import styles from '../sortablePictureItem/SortablePictureItem.module.css'

interface PictureLoadingPlaceholderProps {
  percent: number
}

export const PictureLoadingPlaceholder: React.FC<PictureLoadingPlaceholderProps> = ({ percent }) => {
  const { t } = useTranslation()

  return (
    <div className={`display-flex ${styles.loadingContent} align-items-center justify-content-center gap-s`}>
      <div className={`display-flex ${styles.loaderContainer} align-items-center justify-content-center`}>
        <Loader variant='secondary' colorSet='darkGray' />
      </div>
      <div className={`font-body-small-regular ${styles.progressText}`}>
        {t('wizard.screen.multimedia.webview.modal.picture.loading')}
      </div>
      <div className={`font-body-small-regular ${styles.progressText}`}>{percent}%</div>
    </div>
  )
}
